import { render, staticRenderFns } from "./order_log.vue?vue&type=template&id=b99f9900&scoped=true&"
import script from "./order_log.vue?vue&type=script&lang=js&"
export * from "./order_log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99f9900",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b99f9900')) {
      api.createRecord('b99f9900', component.options)
    } else {
      api.reload('b99f9900', component.options)
    }
    module.hot.accept("./order_log.vue?vue&type=template&id=b99f9900&scoped=true&", function () {
      api.rerender('b99f9900', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/orders/order/tabs/order_log.vue"
export default component.exports